import 'antd/lib/transfer/style';
//# sourceMappingURL=index.js.map